import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { normalizeRole } from '../config/roles';

// These roles do not have a headshot, celebration photo, or insurance section, so they are not asked for them.
const ROLES_WITHOUT_AGENT_PROFILE = ['TC', 'Local Assistant', 'Marketing Manager'];

// Fields an agent must complete before using the system.
// Insurance providers are optional (Oct 28): they stay on the Profile page but don't block anything.
export const profileMissingItems = (profile = {}, insuranceCount = 0, role = '') => {
  const missing = [];
  const skipPhotos = ROLES_WITHOUT_AGENT_PROFILE.includes(normalizeRole(role));
  if (!(profile.firstName || '').trim()) missing.push('First name');
  if (!(profile.lastName || '').trim()) missing.push('Last name');
  if (!(profile.title || '').trim()) missing.push('Title');
  if (!(profile.phone || '').trim()) missing.push('Phone number');
  if (!(profile.contactEmail || '').trim()) missing.push('Email');
  if (!skipPhotos && !profile.profilePhotoUrl) missing.push('Headshot photo');
  if (!skipPhotos && !profile.celebrationPhotoUrl) missing.push('Celebration photo');
  return missing;
};

const cache = new Map();

export const clearProfileStatus = (uid) => cache.delete(uid);

export const loadProfileStatus = async (uid) => {
  if (cache.has(uid)) return cache.get(uid);
  const [profileSnap, insuranceSnap, roleSnap] = await Promise.all([
    get(ref(database, `users/${uid}/profile`)),
    get(ref(database, `users/${uid}/insuranceRecommendations`)),
    get(ref(database, `users/${uid}/role`)),
  ]);
  const picks = Array.isArray(insuranceSnap.val()) ? insuranceSnap.val().filter(Boolean) : [];
  const result = { missing: profileMissingItems(profileSnap.val() || {}, new Set(picks).size, roleSnap.val() || '') };
  cache.set(uid, result);
  return result;
};
